import {Box, FormControl, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import {asset_atom} from 'atoms';
import {useMarketList} from 'hooks/marketHooks';
import {useEffect, useState} from 'react';
import {useRecoilState} from 'recoil';
import LoadingSpinner from './animation/LoadingSpinner';

export default function CryptoSelector() {
	const [asset, set_asset] = useRecoilState(asset_atom);
	const [cur_value, set_cur_value] = useState<string>('');
	const {crypto_list} = useMarketList();

	useEffect(() => {
		if (crypto_list.length > 0) {
			const exists = crypto_list.includes(asset);
			if (exists) set_cur_value(asset);
			else {
				set_cur_value(crypto_list[0]);
				set_asset(crypto_list[0]);
			}
		} else {
			const fallbackAsset = 'BTC';
			set_cur_value(fallbackAsset);
			set_asset(fallbackAsset);
		}
	}, [crypto_list, asset, set_asset]);

	const handleChange = (event: SelectChangeEvent) => {
		set_cur_value(event.target.value);
		set_asset(event.target.value);
	};

	return crypto_list.length === 0 ? (
		<Box height="30px" display="flex" alignItems="center">
			<LoadingSpinner size={20} />
		</Box>
	) : (
		<Box>
			<FormControl>
				<Select
					size="small"
					value={cur_value}
					onChange={handleChange}
					sx={{
						height: '30px',
						fontSize: '0.8rem',
						'.MuiOutlinedInput-notchedOutline': {borderRadius: '4px'},
						'.MuiSelect-select': {padding: '2px 14px 2px 8px'},
					}}
					MenuProps={{
						PaperProps: {
							sx: {
								bgcolor: '#333333',
								maxHeight: 250,
								'& .MuiMenuItem-root': {
									color: '#ffffff',
									'&:hover': {bgcolor: '#444444'},
									'&.Mui-selected': {bgcolor: '#2c5282', '&:hover': {bgcolor: '#3b6eaa'}},
								},
							},
						},
					}}
				>
					{crypto_list.map((cur_value, index) => (
						<MenuItem key={index} value={cur_value}>
							{cur_value.toUpperCase()}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
}
